import { parentApi } from "./message-proxy";

function cleanStackTrace(stack?: string) {
  if (!stack) return undefined;
  // Remove any URLs containing the current domain
  return (
    stack
      .replace(/https?:\/\/[^/]+\//g, "/")
      // Clean up any query parameters
      .replace(/\?[^:\s]+/g, "index.html")
  );
}

export function setupErrorCatching() {
  // Catch unhandled promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    const error = {
      type: "unhandledRejection",
      message: event.reason?.message || "Unknown promise rejection",
      stack: cleanStackTrace(event.reason?.stack),
    };

    parentApi.reportError(error);
  });

  // Catch regular errors
  window.addEventListener("error", (event) => {
    const error = {
      type: "error",
      message: event.message,
      stack: cleanStackTrace(event.error?.stack),
    };

    parentApi.reportError(error);
  });
}
